import React, {Component} from 'react';

export class Header extends Component {
  render () {
    return (
      <div className="Header">
        
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header.js